module.exports = __webpack_public_path__ + "img/bell.df56e22d.svg";